export default __webpack_public_path__ + "static/media/img2.6ecf3fce.jpg";